import { restApi } from '../../api';
import { ValidateOrderProductsOutput, ValidateOrderProductsParams } from './order-product.types';

const PATH = 'orders';

const onlineOrderProductRepository = () => {
  return {
    validateOrderProducts: async (params: ValidateOrderProductsParams) =>
      restApi.get<ValidateOrderProductsOutput>(`${PATH}/${params.orderId}/validate-products`),
  };
};

export default onlineOrderProductRepository;
